// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.fizzwallet",
    name: "Fizz",
    homepage: "https://www.fizzwallet.app/",
    image_id: "f9d4db84-2e9f-4fbe-684f-c1e921c98800",
    app: {
        browser: null,
        ios: "https://apps.apple.com/kr/app/fizz-fun-ezzy-crypto-wallet/id6447460538",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "fizz://wallet-connect",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map